import { motion } from "framer-motion";
import { Brain, Award, Building2, Layers, Scale } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const HIGHLIGHTS = [
  { icon: Award, t: "Especialista em IA", d: "Pioneiro em implantação de IA com automação de processos." },
  { icon: Brain, t: "IA no Backoffice", d: "Formação dos times para adoção de Soluções Vibe e Low Coding" },
  { icon: Layers, t: "Especialista em ERPs e Arquitetura de Soluções", d: "Totvs Protheus, Logix, RM - Oracle e SAP" },
  { icon: Building2, t: "Manufatura & Serviços", d: "Mais de 10 anos implementando Soluções na indústria" },
  { icon: Scale, t: "Reforma Tributária", d: "Adequação ponta a ponta" },
];

const IMAGE = "/founder-david.jpg";

export default function About() {
  const c = useContent("about") || {};
  return (
    <section id="sobre" className="relative py-28 md:py-36" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-cyan-400/20 to-blue-500/10 blur-2xl rounded-3xl" />
            <img
              src={IMAGE}
              alt="David Ponzenato palestrando sobre Transformação Digital"
              className="relative rounded-2xl border border-cyan-400/20 w-full aspect-[4/5] object-cover"
              data-testid="about-image"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="label-eyebrow" data-testid="about-eyebrow">{c.eyebrow || "Sobre a consultoria"}</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
            {c.title || "Quem entende de backoffice complexo resolve — sem café frio."}
          </h2>
          <div className="mt-8 space-y-5 text-lg text-[#B8C0D0] leading-relaxed max-w-2xl">
            <p>{c.paragraph_1 || "Fundada por David Ponzenato - Formado em Sistemas de Informação e Gerenciamento de Projetos pela FGV - Fundação Getúlio Vargas, possui também diversas certificações em gestão de Serviços de TI, Metodologias Ágeis, Ciência de Dados e Inteligência Artificial. Se tornou especialista na Gestão de ERPs, atuando em diversos seguimentos empresariais, como maior foco em Manufatura e Serviços. É pioneiro na adoção de IAs, democratizando soluções de IA, Python e aplicações em todo backoffice, alavancando a Transformação Digital onde realmente gera valor para o negócio."}</p>
            <p>{c.paragraph_2 || "A PONZENA Consultoria, nasceu da percepção de que as empresas ainda operam com processos morosos, arquiteturas obsoletas sistemas amarrados e ausência de KPIs. Nosso compromisso é mapear estes gargalos, modernizar suas aplicações e processos para dar total autonomia aos times e acelerar o progresso do seu negócio."}</p>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="max-w-7xl mx-auto px-6 md:px-12 mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-4 items-stretch"
        data-testid="about-highlights"
      >
        {HIGHLIGHTS.map((h, i) => (
          <div key={i} className="card-surface p-5" data-testid={`about-highlight-${i}`}>
            <h.icon size={22} className="text-cyan-400" />
            <p className="font-display font-semibold text-white mt-3 leading-snug">{h.t}</p>
            <p className="text-sm text-[#8892B0] mt-1">{h.d}</p>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
